import { render, staticRenderFns } from "./PopupWindowDetails.vue?vue&type=template&id=c64e87e4&"
import script from "./PopupWindowDetails.vue?vue&type=script&lang=js&"
export * from "./PopupWindowDetails.vue?vue&type=script&lang=js&"
import style0 from "./PopupWindowDetails.vue?vue&type=style&index=0&id=c64e87e4&prod&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PopupWindowDetails.vue"
export default component.exports